import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import SnapOverlayOp from './SnapOverlayOp';
import RuntimeException from '../../../../../../java/lang/RuntimeException';
import OverlayOp from '../OverlayOp';
var SnapIfNeededOverlayOp = /*#__PURE__*/function () {
  function SnapIfNeededOverlayOp() {
    _classCallCheck(this, SnapIfNeededOverlayOp);
    SnapIfNeededOverlayOp.constructor_.apply(this, arguments);
  }
  _createClass(SnapIfNeededOverlayOp, [{
    key: "getResultGeometry",
    value: function getResultGeometry(opCode) {
      var result = null;
      var isSuccess = false;
      var savedException = null;
      try {
        result = OverlayOp.overlayOp(this._geom[0], this._geom[1], opCode);
        var isValid = true;
        if (isValid) isSuccess = true;
      } catch (ex) {
        if (ex instanceof RuntimeException) savedException = ex;else throw ex;
      } finally {}
      if (!isSuccess) try {
        result = SnapOverlayOp.overlayOp(this._geom[0], this._geom[1], opCode);
      } catch (ex) {
        if (ex instanceof RuntimeException) throw savedException;else throw ex;
      } finally {}
      return result;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geom = new Array(2).fill(null);
      var g1 = arguments[0],
        g2 = arguments[1];
      this._geom[0] = g1;
      this._geom[1] = g2;
    }
  }, {
    key: "overlayOp",
    value: function overlayOp(g0, g1, opCode) {
      var op = new SnapIfNeededOverlayOp(g0, g1);
      return op.getResultGeometry(opCode);
    }
  }, {
    key: "union",
    value: function union(g0, g1) {
      return SnapIfNeededOverlayOp.overlayOp(g0, g1, OverlayOp.UNION);
    }
  }, {
    key: "intersection",
    value: function intersection(g0, g1) {
      return SnapIfNeededOverlayOp.overlayOp(g0, g1, OverlayOp.INTERSECTION);
    }
  }, {
    key: "symDifference",
    value: function symDifference(g0, g1) {
      return SnapIfNeededOverlayOp.overlayOp(g0, g1, OverlayOp.SYMDIFFERENCE);
    }
  }, {
    key: "difference",
    value: function difference(g0, g1) {
      return SnapIfNeededOverlayOp.overlayOp(g0, g1, OverlayOp.DIFFERENCE);
    }
  }]);
  return SnapIfNeededOverlayOp;
}();
export { SnapIfNeededOverlayOp as default };